document.addEventListener('DOMContentLoaded', function () {
  const categoriesMenu = document.querySelector('.categories-menu');
  const categoriesDrawer = document.getElementById('categories-drawer');
  const closeCategoriesDrawer = document.getElementById('close-categories-drawer');
  const closeSubCategoriesDrawer = document.querySelectorAll('.close-subcategories-drawer');
  const backSubCategoriesDrawer = document.querySelectorAll('.back-subcategories-drawer');
  const categories = document.querySelectorAll('.categories__item--has-childs');
  const sectionHeader = document.querySelector('.section-header');
  const body = document.querySelector('body');
  const mainMenuBanner = document.querySelector('.main-menu-banner');
  let bannerClone = null;

  /**
   * Open drawer function
   */
  function openDrawer() {
    categoriesDrawer.classList.add('categories-drawer--active');
    sectionHeader.style.zIndex = '5';
    body.classList.add('drawer-overflow-hidden');
  }

  /**
   * Close drawer function
   */
  function closeDrawer() {
    categoriesDrawer.classList.remove('categories-drawer--active');
    sectionHeader.style.zIndex = '3';
    body.classList.remove('drawer-overflow-hidden');
  }

  /**
   * Close subdrawer function
   *
   * @param element
   */
  function closeSubDrawer(element) {
    element.closest('.subcategories').previousElementSibling.classList.remove('active');
    categoriesDrawer.style.overflow = 'auto';
    if (bannerClone) {
      bannerClone.remove();
      bannerClone = null;
    }
  }

  categoriesMenu.addEventListener('click', function (e) {
    if (window.innerWidth < 1024) {
      openDrawer();
    }
  });

  closeCategoriesDrawer.addEventListener('click', closeDrawer);

  closeSubCategoriesDrawer.forEach((item) => {
    item.addEventListener('click', function (event) {
      event.stopPropagation();
      closeSubDrawer(item);
      closeDrawer();
    });
  });

  backSubCategoriesDrawer.forEach((item) => {
    item.addEventListener('click', function (event) {
      event.stopPropagation();
      closeSubDrawer(item);
    });
  });

  categories.forEach((category) => {
    const arrows = category.querySelector('.arrows');
    arrows.addEventListener('click', function (event) {
      event.stopPropagation();
      category.classList.toggle('active');
      categoriesDrawer.style.overflow = 'hidden';
      if (bannerClone) {
        bannerClone.remove();
        bannerClone = null;
      }
      if (mainMenuBanner) {
        bannerClone = mainMenuBanner.cloneNode(true);
        bannerClone.classList.add('banner-clone');
        category.nextElementSibling.querySelector('.subcategories-banner').appendChild(bannerClone);
      }
    });
  });
});
